import {RestResource} from "../rest";
import {ASSESSMENT_SERVER} from "../server";
import {athubAxios} from "../../util/athub-axios";

const assessmentVersion = new RestResource({server: ASSESSMENT_SERVER, resource: 'assessmentVersion'});

assessmentVersion.revise = (assessmentVersionDetail) => {
    let url = `${ASSESSMENT_SERVER}/assessmentVersion/revise`;
    return new Promise((resolve, reject) => {
        athubAxios.post(url, {
            id: assessmentVersionDetail.id,
            version: assessmentVersionDetail.version,
            changeby: localStorage.getItem('realname'),
            reviseby: localStorage.getItem('realname'),
        }, {loading: true}).then(responseBody => {
            if (responseBody.status == 200) {
                resolve(responseBody.data);
            }
        }).catch(error => {
            reject(error);
        });
    });
}

export default assessmentVersion;